module.exports = __webpack_public_path__ + "img/IMG_87001.6716239b.jpeg";